import apiKeys from './apiKeys'
import builder from './builder'
import configs from './configs'
import fdpIndex from './fdpIndex'
import forms from './forms'
import info from './info'
import label from './label'
import repository from './repository'
import memberships from './memberships'
import profiles from './profiles'
import reset from './reset'
import resourceDefinition from './resourceDefinitions'
import metadataSchemas from './metadataSchemas'
import search from './search'
import searchIndex from './searchIndex'
import settings from './settings'
import tokens from './tokens'
import users from './users'

export default {
  apiKeys,
  builder,
  configs,
  fdpIndex,
  forms,
  info,
  label,
  memberships,
  profiles,
  repository,
  reset,
  resourceDefinition,
  metadataSchemas,
  search,
  searchIndex,
  settings,
  tokens,
  users,
}
